<div class="header-Container">
  <div class="row" *ngIf="reservationNum !='' && reservationNum !==undefined">
    <div class="col-9">
      <h4 class="prodCat-title">Reservation # {{reservationNum}}</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-8">
      <span class="activeSeasonId">
        {{activeSeasonId}} {{'selectVaccines.season'|cxTranslate}}
      </span>
      <span class="activeSeasonId" *ngIf="reservationStatus !== '' && reservationStatus !==undefined">
        | {{reservationStatus}}
      </span>
      <span *ngIf="reservationStatus !== '' && reservationStatus !==undefined">
        <img *ngIf="reservationStatus === 'Confirmed'" class="mb-2 ml-1" src="../../../assets/icons/confirm.png"
          alt="status" />
        <img *ngIf="reservationStatus === 'Partially confirmed'" class="mb-2 ml-1"
          src="../../../assets/icons/part-confirm.png" alt="status" />
        <img *ngIf="reservationStatus === 'Not confirmed'" class="mb-2 ml-1" src="../../../assets/icons/not-confirm.png"
          alt="status" />
      </span>
      <span *ngIf="reservationStatus == 'Not confirmed' || reservationStatus == 'Partially confirmed'"
        class="ml-3 red-text not-confirmed-flu-uniq" [innerHTML]="notConfirmedMessage">
        <!-- {{notConfirmedMessage}} -->
      </span>
    </div>
    <div class="col-12 bc-Dash-Div no-print">
      <a (click)='backToDashboard()'>
        <img src='assets/icons/{{baseSiteId}}/chevron-left_green.svg' class="svg-Images" alt="left">
        {{'selectVaccines.back_to_db'|cxTranslate}}</a>&nbsp;&nbsp;
      <a class="excel-download mr-1" (click)="exportXls()"><img class="mr-1 w-auto"
          src="assets/icons/{{baseSiteId}}/excel_new.png" alt="XLS" />
        <span>{{ "orderDetail.xls" | cxTranslate }}</span></a>&nbsp;&nbsp;
      <a class="print mr-3" (click)="OnFluPrint()">
        <img src="assets/icons/{{baseSiteId}}/print.svg" class="svg-Images" alt="print">
        {{'selectVaccines.print'|cxTranslate}}</a>
    </div>
  </div>
</div>
<div class="reservation-style" *ngIf="stsFlag && (reservationStatus === 'Confirmed' || reservationStatus === 'Shipped')">
  <div class="row">
    <div class="col-xs-12 col-md-12 col-sm-12 col-lg-12 reservation-dashboard">
      <div class="tabs-Section-Container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-9 col-lg-10 large-Device-Tabs">
            <ul class="nav nav-tabs">
              <li class="nav-item mr-3 p-overview"
                [ngClass]="{'nav-Item-Border': tabSelected == 'reservationOverview'}">
                <span (click)="tabNavigation('reservationOverview', 'reservationOverview')">
                  {{'Overview'}}
                </span>
              </li>
              <li class="nav-item p-schedule" [ngClass]="{'nav-Item-Border': tabSelected == 'reservationSchedule'}">
                <span (click)="tabNavigation('reservationSchedule', 'reservationSchedule')">
                  {{'Shipping schedule'}}
                </span>
              </li>
            </ul>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-2 edit-reservation-btn-mobile-view">
            <button class="btn-secondary edit-res" *ngIf="reservationStatus === 'Confirmed' && showEditCTAShip"
            [hidden]="userReceivingHours" (click)="redirectToSelectVaccine()">Edit reservation</button>
          </div>
        </div>
      </div>
      <div class="tab-contents">
        <div id="reservationOverview">
          <app-reservation-overview [reservationNo]="reservationNum"
            (tabSelectedEvent)="tabNavigation('reservationSchedule', 'reservationSchedule')"></app-reservation-overview>
        </div>
        <div id="reservationSchedule">
          <app-reservation-sts-details [reservationNo]="reservationNum"></app-reservation-sts-details>
        </div>
      </div>
    </div>
  </div>

</div>
<div class="reservation-style"
  *ngIf="!stsFlag &&(reservationStatus === 'Confirmed' || reservationStatus === 'Shipped')">
  <div class="col">
    <div class="col-xs-12 col-md-12 col-sm-12 col-lg-12 reservation-dashboard">
      <div class="tabs-Section-Container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9 large-Device-Tabs">
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <button class="btn-secondary float-right edit-res" *ngIf="reservationStatus === 'Confirmed' && showEditCTAShip" 
            [hidden]="userReceivingHours" (click)="redirectToSelectVaccine()">Edit reservation</button>
          </div>
        </div>
      </div>
      <div class="tab-contents">
        <div>
          <app-reservation-overview [reservationNo]="reservationNum"></app-reservation-overview>
        </div>
      </div>
    </div>
  </div>

</div>